/* Detailing1 Paket D 2026-09: Mega-Menü – Menügruppen (<details> mit summary.js-no-toggle-md) lassen sich ab Desktop nicht mehr zuklappen.
   Das Theme setzt die Klasse, wertet sie aber nirgends aus; ein Klick neben die Überschrift schloss die Gruppe. */
(function () {
  const isDesktop = () => (window.theme && theme.mediaMatches && typeof theme.mediaMatches.md === 'boolean') ? theme.mediaMatches.md : window.matchMedia('(min-width: 769px)').matches;
  // Klick auf den Summary-Bereich (nicht auf einen Link) ab Desktop ignorieren
  document.addEventListener('click', (evt) => {
    const summary = evt.target.closest('summary.js-no-toggle-md');
    if (!summary || !isDesktop() || summary.classList.contains('js-sidebar-hover')) return;
    if (evt.target.closest('a[href]')) return;
    evt.preventDefault();
  }, true);
  // Sicherheitsnetz (Tastatur etc.): geschlossene Gruppen ab Desktop sofort wieder öffnen
  document.addEventListener('toggle', (evt) => {
    const details = evt.target;
    if (!(details instanceof HTMLDetailsElement) || details.open || !isDesktop()) return;
    const summary = details.querySelector(':scope > summary.js-no-toggle-md');
    if (summary && !summary.classList.contains('js-sidebar-hover')) details.open = true;
  }, true);
})();
